import { CREATE_NEW_VERSION_REQUEST, CREATE_NEW_VERSION_SUCCEEDED, CREATE_NEW_VERSION_FAILED, INVALIDATE_CREATE_STATE, FETCH_VERSIONS_REQUEST, 
FETCHING_VERSIONS_SUCCEEDED, FETCHING_VERSIONS_FAILED, FETCH_VERSION_REQUEST, FETCHING_VERSION_SUCCEEDED, FETCHING_VERSION_FAILED,
DELETE_VERSION_REQUEST, DELETING_VERSION_FAILED, DELETING_VERSION_SUCCEEDED, RENAME_VERSION_REQUEST, RENAMING_VERSION_FAILED,
RENAMING_VERSION_SUCCEEDED, RESTORE_VERSION_REQUEST, RESTORING_VERSION_FAILED, RESTORING_VERSION_SUCCEEDED, INVALIDATE_RESTORE_STATE
} from "constants/actionTypes";

import { call, put, takeEvery, select } from "redux-saga/effects";
import axios from "axios";
import { createAction } from "redux-actions";
import _ from "lodash";

const cleverstoryApiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const VERSIONS_BASE_URL = `${cleverstoryApiUrl}/api/2.0/snapshot`;

/*
 * Create New Version
 */

export const createNewVersion = createAction(CREATE_NEW_VERSION_REQUEST, (request, callback) => {
    return { 
      request: request,
      callback: callback
    };
});

const createNewVersionSucceeded = createAction(CREATE_NEW_VERSION_SUCCEEDED, (response) => {
    return {
        response: response,
    };
});

const createNewVersionFailed = createAction(CREATE_NEW_VERSION_FAILED, (error) => {
    return {
        error: error,
    };
});

export const invalidateCreateState = createAction(INVALIDATE_CREATE_STATE);

function* createNewVersionSaga(action) {
  const {request, callback} = action.payload;

  const createNewVersionAPI = () => {
    return axios
      .post(`${VERSIONS_BASE_URL}`, request)
      .then((response) => response.data);
  };

  try {
    const response = yield call(createNewVersionAPI);
    
    if (response) {
      yield put(createNewVersionSucceeded(response));

      if(callback){
        callback();
      }
    }
  } catch (error) {
    yield put(createNewVersionFailed(error));
  }
}

/*
 *  Fetching All Versions
 */

export const fetchVersions = createAction(FETCH_VERSIONS_REQUEST,(storyboard) => {
    return storyboard;
  }
);

const fetchingVersionsSucceeded = createAction(FETCHING_VERSIONS_SUCCEEDED,(response) => {
    return response;
  }
);

const fetchingVersionsFailed = createAction(FETCHING_VERSIONS_FAILED,(error) => {
    return error;
  }
);

function* fetchVersionsSaga(action) {
  const storyboard = action.payload;
  let url = `${VERSIONS_BASE_URL}/storyboard/${storyboard}`;

  const fetchVersionsAPI = () => {
    return axios.get(url).then((response) => response.data);
  };

  try {
    const response = yield call(fetchVersionsAPI);
    if (response) {
      yield put(fetchingVersionsSucceeded(response));
    }
  } catch (error) {
    yield put(fetchingVersionsFailed(error));
  }
}

/*
 * Delete Version
 */

export const deleteVersion = createAction(DELETE_VERSION_REQUEST, (id, callback) => {
  return {
    id: id,
    callback: callback
  };
});

const deleteVersionSucceeded = createAction(DELETING_VERSION_SUCCEEDED,(id) => {
    return id;
  }
);

const deleteVersionFailed = createAction(DELETING_VERSION_FAILED,(error) => {
    return error;
  }
);

function* deleteVersionSaga(action) {
  const {id, callback} = action.payload;

  let url = `${VERSIONS_BASE_URL}/${id}`;

  const deleteVersionAPI = () => {
    return axios.delete(url).then((response) => response.data);
  };

  try {
    const response = yield call(deleteVersionAPI);
    if (response) {
      yield put(deleteVersionSucceeded(id));

      if(callback){
        callback();
      }
    }
  } catch (error) {
    yield put(deleteVersionFailed(id, error));
  }
}

/*  Fetching Version
 */
export const fetchVersion = createAction(FETCH_VERSION_REQUEST, (request) => {
    return request;
});

const fetchingVersionSucceeded = createAction(FETCHING_VERSION_SUCCEEDED, (response) => {
    return response;
});

const fetchingVersionFailed = createAction(FETCHING_VERSION_FAILED, (error) => {
  return error;
});

function* fetchVersionSaga(action) {
  const request = action.payload;
  let url = `${VERSIONS_BASE_URL}/preview`;

  const fetchVersionAPI = () => {
    return axios.post(url, request).then((response) => response.data);
  };

  try {
    const response = yield call(fetchVersionAPI);
    if (response) {
      yield put(fetchingVersionSucceeded(response));
    }
  } catch (error) {
    yield put(fetchingVersionFailed(error));
  }
}

/*
 * Restore Version
 */

export const restoreVersion = createAction(RESTORE_VERSION_REQUEST, (id, callback) => {
    return {
      id: id,
      callback: callback
    };
});

const restoreVersionSucceeded = createAction(RESTORING_VERSION_SUCCEEDED, (response) => {
    return response;
});

const restoreVersionFailed = createAction(RESTORING_VERSION_FAILED, (error) => {
    return error;
});

export const invalidateRestoreState = createAction(INVALIDATE_RESTORE_STATE);

function* restoreVersionSaga(action) {
  const {id, callback} = action.payload;

  let url = `${VERSIONS_BASE_URL}/${id}/restore`;

  const restoreVersionAPI = () => {
    return axios.get(url).then((response) => response.data);
  };

  try {
    const response = yield call(restoreVersionAPI);
    if (response) {
      yield put(restoreVersionSucceeded(response));
      if(callback){
        callback(response);
      }
    }
  } catch (error) {
    yield put(restoreVersionFailed(error));
  }
}

/*
 * Renaming Version
 */

export const renameVersion = createAction(RENAME_VERSION_REQUEST, (request) => {
    return request
});

const renamingVersionSucceeded = createAction( RENAMING_VERSION_SUCCEEDED, (response) => {
    return response;
});

const renamingVersionFailed = createAction(RENAMING_VERSION_FAILED, (error) => {
    return error;
});

function* renameVersionSaga(action) {
  const request = action.payload;

  let url = `${VERSIONS_BASE_URL}`;

  const renameVersionAPI = () => {
    return axios.put(url, request).then((response) => response.data);
  };

  try {
    const response = yield call(renameVersionAPI);
    if (response) {
      yield put(renamingVersionSucceeded(response));
    }
  } catch (error) {
    yield put(renamingVersionFailed(error));
  }
}

export default function* versionsSaga() {
  yield takeEvery(CREATE_NEW_VERSION_REQUEST, createNewVersionSaga);
  yield takeEvery(FETCH_VERSIONS_REQUEST, fetchVersionsSaga);
  yield takeEvery(FETCH_VERSION_REQUEST, fetchVersionSaga);
  yield takeEvery(DELETE_VERSION_REQUEST, deleteVersionSaga);
  yield takeEvery(RESTORE_VERSION_REQUEST, restoreVersionSaga);
  yield takeEvery(RENAME_VERSION_REQUEST, renameVersionSaga);
}
